import { useQuery } from 'hooks/useCustomQuery';
import getAllTRSRegistrationsByCompanyId from '@/API/TRSRegistration/getTRSRegistrationsByCompanyId';

const useGetAllTRSRegistrations = (
    currentScope,
    currentCompany,
    enabled = true,
) => {
    return useQuery({
        queryKey: ['TRSRegistrations Available'],
        queryFn: () => {
            const data = getAllTRSRegistrationsByCompanyId(
                currentScope,
                currentCompany,
            );
            return data;
        },
        refetchOnWindowFocus: false,
        staleTime: 10 * 60 * 1000, // 10 minutes
        enabled: !!currentCompany && enabled,
        retry: 1,
    });
};

export default useGetAllTRSRegistrations;
